import * as Actions from '../actions/actions'

export const updateFeedback = (store, capturedLocation, paneId, value) => {
    let capturedFeedback = store.getState()["History"][capturedLocation] || [];
    
    capturedFeedback.push({
        paneId,
        value
    });

    store.dispatch(Actions.setCapturedFeedback(capturedFeedback, capturedLocation));
};

export const addOrUpdateFeedbackById = (store, capturedLocation, paneId, value) =>
{
    let capturedFeedback = store.getState()["History"][capturedLocation] || [];
    let index = capturedFeedback.findIndex(feedback => feedback.paneId === paneId);

    if (index === -1)
    {
        capturedFeedback.push({ paneId, value })
    }
    else
    {
        value.label = Object.assign({}, capturedFeedback[index].value.label, value.label);
        capturedFeedback[index] = Object.assign({}, capturedFeedback[index], { value });
    }

    store.dispatch(Actions.setCapturedFeedback(capturedFeedback, capturedLocation));
};

export const endFeedback = (store, capturedLocation, capturedStageLocation, paneId, value) => {
    updateFeedback(store, capturedLocation, paneId, value);

    store.dispatch(Actions.sendCapturedFeedback(capturedStageLocation, capturedLocation));

    store.dispatch(Actions.clearCapturedFeedback(capturedLocation));
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-feedback-overlay/src/utilities/capture-tools.js